<template>
	<div class="container">
		<div
			v-for="(item, index) in props.menuList"
			:key="index"
			:class="[{ on: currentTab === `${item}` }, 'container_item']"
			@click="onSelectTab(item, props.queryKey)"
		>
			{{ item }}
		</div>
	</div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

// -----variable-----
const emit = defineEmits(['update:tab']);
const props = defineProps<{
	menuList: string[];
	queryKey: string | number;
}>();

const router = useRouter();
const route = useRoute();

const currentTab = computed(() => route.query[`tab${props.queryKey}`] ?? props.menuList[0]);

// -----function-----
const onClickSort = (tab: string, key: string | number) => {
	if (route.query[`sort${key}`]) {
		delete route.query[`sort${key}`];
	}
	router.replace({ query: { ...route.query, [`tab${key}`]: tab } });
};

const onSelectTab = (sort: string, key: string | number) => {
	onClickSort(sort, key);
	emit('update:tab', sort);
};
</script>

<style lang="scss" scoped>
.container {
	display: flex;
	font-weight: var(--font-w-medium);
	font-size: var(--font-s-regular);
	color: var(--color-base-light);
	&_item {
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: center;
		height: 5.2rem;
		border-bottom: 1px solid var(--color-base-mid-dark);
		cursor: pointer;
	}
	.on {
		border-color: var(--color-primary);
		color: var(--color-primary);
	}
}
</style>
